import { Controller } from '@hotwired/stimulus';

import { bindLinkKeyboardActivation } from '../utils/link_keyboard_activation';

export default class extends Controller {
  connect() {
    this.unbind = bindLinkKeyboardActivation(this.element);
  }

  disconnect() {
    if (this.unbind) this.unbind();
  }
}
